import ThemeModal from "components/Common/ThemeModal";
import { Row, Col, Table, Button } from "reactstrap";
import PettyCashBillPay from "./PettyCashBillPay";
import React from "react";
import { formatUiDate, formatUiDateTime } from "utils/formatDate";

const vehicleLabel = vehicle => {
  if (!vehicle) return "-";

  return [vehicle.stock_id, vehicle.full_chassis].filter(Boolean).join(" / ") || "-";
};

const itemVehicleLabel = item => {
  if (item.vehicle) return vehicleLabel(item.vehicle);
  if (item.vehicle_id) return `#${item.vehicle_id}`;
  return "-";
};

const PettyCashBillView = ({ modal, toggleModal, bill }) => {
  const [payModal, setPayModal] = React.useState(false);
  const togglePayModal = () => setPayModal(!payModal);

  if (!bill) return null;

  const items = Array.isArray(bill.items) ? bill.items : [];
  const hasItemVehicle = items.some(item => item.vehicle_id || item.vehicle);

  return (
    <>
      <ThemeModal isOpen={modal} toggle={toggleModal} title={`Bill ${bill.bill_no}`}>
        <Row>
          <Col sm={6}><b>Bill Date:</b> {formatUiDate(bill.bill_date)}</Col>
          <Col sm={6}><b>Status:</b> {bill.status}</Col>
          {!hasItemVehicle && <Col sm={6}><b>Vehicle:</b> {vehicleLabel(bill.vehicle)}</Col>}
          <Col sm={6}><b>Submitted By:</b> {bill.submitted_by_name}</Col>
        </Row>

        <hr />
        <h6>Items</h6>
        <Table size="sm">
          <thead>
            <tr><th>Payment For</th><th>Vehicle</th><th>Description</th><th>Amount</th></tr>
          </thead>
          <tbody>
            {items.map((i, idx) => <tr key={idx}>
              <td>{i.payment_for_name}</td>
              <td>{itemVehicleLabel(i)}</td>
              <td>{i.description}</td>
              <td>{i.amount}</td>
            </tr>)}
          </tbody>
        </Table>

        <h6>Payments</h6>
        <Table size="sm">
          <thead>
            <tr><th>Date</th><th>Amount</th><th>Mode</th></tr>
          </thead>
          <tbody>
            {(bill.payments || []).map((p, idx) => <tr key={idx}>
              <td>{formatUiDateTime(p.payment_date)}</td>
              <td>{p.amount}</td>
              <td>{p.payment_mode_name}</td>
            </tr>)}
          </tbody>
        </Table>

        {bill.status !== "paid" && <Button color="success" onClick={togglePayModal}>Pay Bill</Button>}
      </ThemeModal>

      <PettyCashBillPay modal={payModal} toggleModal={togglePayModal} bill={bill} />
    </>
  );
};

export default PettyCashBillView;
